<fieldset class="slider-fieldset"
    [ngClass]="{'disabled' : sliderSettings.disabled}">
    <div class="row">
        <div class="col-12 col-md-6">
            <legend class="slider-fieldset-legend mb-2">
                <span *ngIf="!isMobileDevice()">
                    {{sliderSettings.caption | translate}}
                </span>
                <span *ngIf="isMobileDevice()">
                    {{sliderSettings.shortCaption | translate}}
                </span>
            </legend>
        </div>
        <div class="col-12 col-md-6">
            <div class="input-group input-group-slider mb-2" [ngClass]="{'pointer-events-none' : sliderSettings.disabled}">
                <input
                    [id]="'txt-' + sliderIdPrefix"
                    type="text"
                    class="form-control text-center"
                    notab="notab"
                    disabled="disabled"
                    [ngClass]="{'has-error' : !!errorMessage && !sliderSettings.disabled}"
                    attr.aria-label="{{sliderSettings.shortCaption | translate}}"
                    value="{{value === 0 ? ((sliderSettings.SpecialValue==='NONE' || sliderSettings.SpecialValue==='GLOBAL.NONE'  || sliderSettings.SpecialValue==='GLOBAL.NO')?( sliderSettings.SpecialValue |translate):sliderSettings.SpecialValue)  : (sliderSettings.unit === '$'? '$': '') + (value | number) + (sliderSettings.unit === '%'? '%': '')}}"
                    readonly />                
                <app-cea-help-button
                    [stype]="'input'"
                    [title]="sliderSettings?.helpSlug.title"
                    [text1]="sliderSettings?.helpSlug.text">
                </app-cea-help-button>               
                <span class="input-group-text input-group-text-required" aria-hidden="true">
                    <em *ngIf="!sliderSettings.disabled">*</em>
                </span>
            </div>
        </div>
    </div>  
    <div class="slider-dividers d-flex justify-content-center">
        <div class="slider-range pr-2">
            <span *ngIf="!sliderSettings?.isReversed">
                {{sliderSettings?.leftLabel | translate}}
            </span>
            <span *ngIf="sliderSettings?.isReversed">
                {{sliderSettings?.rightLabel | translate}}
            </span>
        </div>
        <div class="slider-control"
            [ngClass]="{'has-error' : errorMessage !== '' && !sliderSettings.disabled}">
            <ngx-slider 
                [(value)]="value" 
                [options]="options" 
                (valueChange)="sliderValueChanged(sliderSettings.sliderKey)">
            </ngx-slider>
        </div>
        <div class="slider-range pl-2">
            <span *ngIf="sliderSettings?.isReversed">
                {{sliderSettings?.leftLabel | translate}}
            </span>
            <span *ngIf="!sliderSettings?.isReversed">
                {{sliderSettings?.rightLabel | translate}}
            </span>
        </div>
    </div> 
    <div class="alert alert-danger text-center"
        *ngIf="errorMessage !== '' && !sliderSettings.disabled">
        {{(errorMessage | translate).replace('[#]', errorMessageReplaceText)}}        
    </div>         
</fieldset>   